<div class="deposit-conmponent">
  <div class="header">
    <mat-icon class="icon-order" svgIcon="file"></mat-icon>
    <span>{{ title }}</span>
    <mat-icon class="close-btn" svgIcon="close" (click)="close()"></mat-icon>
  </div>
  <div class="deposit-content">
    <div class="col-12 spinner" *ngIf="loading">
      <app-spinner-loading></app-spinner-loading>
    </div>
    <div class="col-8 content" *ngIf="!loading">
      <mat-tab-group (selectedTabChange)="changeTab($event)" [selectedIndex]="tabIndex" *ngIf="!loading">
        <mat-tab label="Retirada">
          <form id="form-redemption" class="form-deposit" [formGroup]="redemptionForm">
            <ng-template #selectAccount>
              <div class="row input">
                <mat-form-field>
                  <mat-label>Conta</mat-label>
                  <mat-select formControlName="account_group">
                    <mat-option class="auto-height-option" *ngFor="let account of listAccounts" [value]="account">
                      <ng-container [ngTemplateOutlet]="accountSelectTemplate" [ngTemplateOutletContext]="{account: account}"></ng-container>
                    </mat-option>
                  </mat-select>
                  <mat-error *ngIf="redemptionForm.controls['account_group'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
            </ng-template>

            <ng-template #accountSelectTemplate let-account="account">
              <div class="account-template">
                <p>{{account.bank}} </p>
                <span>Agência: {{ account.bankAgency }} - Conta: {{ account.bankAccount }}</span>
              </div>
            </ng-template>

            <ng-template #manualAccount>
              <div class="row input">
                <mat-form-field>
                  <mat-label>Banco</mat-label>
                  <input id="bank" matInput onlyLetters trim formControlName="bank" minlength="2">
                  <!-- TODO: Aguardando Serviço ser desenvolvido -->
                  <!-- <mat-select id="select-bank" formControlName="bank">
                    <mat-option id="option-broker-{{item.id}}" class="custom-option"
                      *ngFor="let item of banksDeposit" [value]="item.id">
                      {{item.desc}}
                    </mat-option>
                  </mat-select> -->
                  <mat-error *ngIf="redemptionForm.controls['bank'].hasError('required')">
                    Campo obrigatório
                  </mat-error>
                </mat-form-field>
              </div>
              <div class="row input">
                <div class="col-6 pad-l-0">
                  <mat-form-field>
                    <mat-label>Agência</mat-label>
                    <input id="agency" matInput trim formControlName="agency" minlength="3">
                    <mat-error *ngIf="redemptionForm.controls['agency'].hasError('required')">
                      Campo obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
                <div class="col-6 pad-r-0">
                  <mat-form-field>
                    <mat-label>Conta</mat-label>
                    <input id="account" matInput trim formControlName="account" minlength="2">
                    <mat-error *ngIf="redemptionForm.controls['account'].hasError('required')">
                      Campo obrigatório
                    </mat-error>
                  </mat-form-field>
                </div>
              </div>
            </ng-template>


            <div class="col-12">
              <div class="row input">
                <div class="col-6">

                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Favorecido</mat-label>
                      <input id="favored" [value]="account" matInput onlyLetters trim formControlName="favored"
                             minlength="2">
                      <mat-error *ngIf="redemptionForm.controls['favored'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                      <mat-error
                        *ngIf="redemptionForm.controls['favored'].hasError('invalidName') && !redemptionForm.controls['favored'].hasError('required')">
                        Por favor, informe um favorecido valido
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Origem</mat-label>
                      <input id="source" matInput trim formControlName="source" minlength="2">
                      <!-- TODO: Aguardando Serviço ser desenvolvido -->
                      <!-- <mat-select id="select-source" formControlName="source">
                        <mat-option id="option-broker-{{item.id}}" class="custom-option"
                          *ngFor="let item of origimDeposit" [value]="item.id">
                          {{item.origin}}
                        </mat-option>
                      </mat-select> -->
                      <mat-error *ngIf="redemptionForm.controls['source'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <ng-container *ngIf="showRedemptionAccount; then selectAccount; else manualAccount"></ng-container>

                </div>
                <div class="col-6">
                  <div class="row input">
                    <mat-checkbox id="check-box-withdrawal" formControlName="total_withdrawal_checked">
                      Retirada total
                    </mat-checkbox>
                  </div>
                  <div class="row input">
                    <app-incremental-input class="price" name="value" ondragstart="return false;" ondrop="return false;"
                                           id="value" [options]="priceValuesFormatOptions" [roundLot]="'1.00'"
                                           [isDisabled]="redemptionForm?.controls['total_withdrawal_checked']?.value"
                                           [maxlength]="999999999999" [isQuantity]="true" [price]="true"
                                           formControlName="value" aria-required="" [minValue]="0"
                                           maxValue="999999999999">
                    </app-incremental-input>
                  </div>
                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Valor por extenso</mat-label>
                      <input id="described_value" matInput onlyLetters trim formControlName="described_value">
                      <mat-error *ngIf="redemptionForm.controls['described_value'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                      <mat-error
                        *ngIf="redemptionForm.controls['described_value'].hasError('invalidName') && !redemptionForm.controls['value'].hasError('required')">
                        Por favor, informe o valor da retirada
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row input">
                    <mat-form-field class="example-full-width">
                      <mat-label>Observações</mat-label>
                      <textarea matInput id="comments" [rows]="3" formControlName="comments"></textarea>
                    </mat-form-field>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="col-12 button m-btn" *ngIf="!loading">
            <button [ngClass]="{'error': tabIndex === 0 ? redemptionForm.invalid : depositForm.invalid,
              'success': tabIndex === 0 ? redemptionForm.valid : depositForm.valid }" mat-raised-button
                    color="primary02" class="animated sm" type="submit" (click)="send()"
                    [disabled]="tabIndex === 0 ? redemptionForm.invalid : depositForm.invalid">
              {{ tabIndex === 0 ? 'TRANSFERIR' : 'INFORMAR DEPÓSITO' }}
            </button>
          </div>
        </mat-tab>
        <mat-tab label="Informar depósito">
          <form id="form-redemption" class="form-deposit" [formGroup]="depositForm">
            <div class="col-12">
              <div class="row input">
                <div class="col-6">

                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Depositante</mat-label>
                      <input id="favored" [value]="account" matInput onlyLetters trim formControlName="favored"
                             minlength="2">
                      <mat-error *ngIf="depositForm.controls['favored'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                      <mat-error
                        *ngIf="depositForm.controls['favored'].hasError('invalidName') && !depositForm.controls['favored'].hasError('required')">
                        Por favor, informe um favorecido valido
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Banco</mat-label>
                      <input id="bank" matInput onlyLetters trim formControlName="bank" minlength="2">
                      <!-- <mat-select id="select-bank" formControlName="bank">
                        <mat-option id="option-broker-{{item.id}}" class="custom-option"
                          *ngFor="let item of banksDeposit" [value]="item.id">
                          {{item.desc}}
                        </mat-option>
                      </mat-select> -->
                      <mat-error *ngIf="depositForm.controls['bank'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>

                  <div class="row input">
                    <div class="col-6 pad-l-0">
                      <mat-form-field>
                        <mat-label>Agência</mat-label>
                        <input id="agency" matInput trim formControlName="agency" minlength="2">
                        <mat-error *ngIf="depositForm.controls['agency'].hasError('required')">
                          Campo obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>

                    <div class="col-6 pad-r-0">
                      <mat-form-field>
                        <mat-label>Conta</mat-label>
                        <input id="account" matInput trim formControlName="account" minlength="2">
                        <mat-error *ngIf="depositForm.controls['account'].hasError('required')">
                          Campo obrigatório
                        </mat-error>
                      </mat-form-field>
                    </div>

                  </div>
                </div>
                <div class="col-6">
                  <div class="row input">
                    <mat-form-field>
                      <mat-label>Origem</mat-label>
                      <input id="destination" matInput trim formControlName="destination" minlength="2">
                      <!-- TODO: Aguardando Serviço ser desenvolvido -->
                      <!-- <mat-select id="select-destination" formControlName="destination">
                        <mat-option id="option-broker-{{item.id}}" class="custom-option"
                          *ngFor="let item of origimDeposit" [value]="item.id">
                          {{item.origin}}
                        </mat-option>
                      </mat-select> -->
                      <mat-error *ngIf="depositForm.controls['destination'].hasError('required')">
                        Campo obrigatório
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div class="row input">
                    <app-incremental-input class="price" [ngClass]="{'deposit': tabIndex === 1}" name="value"
                                           ondragstart="return false;" ondrop="return false;" id="value"
                                           [options]="priceValuesFormatOptions" [roundLot]="'1.00'"
                                           [maxlength]="999999999999"
                                           [isQuantity]="true" [price]="true" formControlName="value" aria-required=""
                                           [minValue]="0"
                                           maxValue="999999999999">
                    </app-incremental-input>
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="col-12 button m-btn" *ngIf="!loading">
            <button [ngClass]="{'error': tabIndex === 0 ? redemptionForm.invalid : depositForm.invalid,
              'success': tabIndex === 0 ? redemptionForm.valid : depositForm.valid }" mat-raised-button
                    color="primary02" class="animated sm" type="submit" (click)="send()"
                    [disabled]="tabIndex === 0 ? redemptionForm.invalid : depositForm.invalid">
              {{ tabIndex === 0 ? 'TRANSFERIR' : 'INFORMAR DEPÓSITO' }}
            </button>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
